<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Notification from "@/services/Notification";
import Swal from "sweetalert2";
import Sortable from "sortablejs";

/**
 * Starter page
 */
export default {
  components: { Layout, PageHeader },
  page: {
    title: "Notifications Types",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
        title: "Notifications Types",
        items: [
          {
            text: "Notifications",
            href: "/",
          },
            {
                text: "Notifications Types",
                href: "/notifications_types",
            },
        ],
        notificationSetup: null,
        notificationSetupLoading: false,
        notificationSetupCompleted: true,
        selectedNotificationType: null,
        isBusy: false,
        isBusyDefinitions: false,
        tableData: [],
        newDefinitions: [],
        side_menu_list: localStorage.getItem("access_objects"),
        sortableInstance: null,
        childSortableInstances: {},
        fields: [
            {
              key: "drag",
              label: "",
              tdClass: "text-center",
            },
            {
              key: "expand",
              label: "",
              tdClass: "text-center",
            },
            {
              key: "type_code",
              label: "Type Code",
            },
            {
                key: "type_name",
                label: "Type Name",
            },
            {
              key: "fcm_type",
              label: "FCM Types",
            },
            {
              key: "localization_key_title",
              label: "Localization Title",
            },
            {
              key: "localization_key_desc",
              label: "Localization Description",
            },
            {
              key: "app_order",
              label: "Order",
            },
          {
            key:"system",
            label:"System",
          },
            {
              key: "active",
              label: "Active",
            },
        ],
        subCategoryFields: [
            {
              key: "drag",
              label: "",
              tdClass: "text-center",
            },
            {
              key: "type_code",
              label: "Type Code",
            },
            {
                key: "type_name",
                label: "Type Name",
            },
            {
              key: "parent",
              label: "Parent",
            },
            {
              key: "app_order",
              label: "Order",
            },
            {
              key: "fcm_type",
              label: "FCM Types",
            },
            {
              key: "localization_key_title",
              label: "Localization Title",
            },
            {
              key: "localization_key_desc",
              label: "Localization Description",
            },
            {
              key:"system",
              label:"System",
            },
            {
              key: "active",
              label: "Active",
            },
        ],
        definitionFields: [
            {
              key: "expand",
              label: "",
              tdClass: "text-center",
            },
            {
              key: "type_code",
              label: "Type Code",
            },
            {
              key: "type_name",
              label: "Type Name",
            },
            {
              key: "fcm_type",
              label: "FCM Types",
            },
            {
              key: "localization_key_title",
              label: "Localization Title",
            },
            {
              key: "localization_key_desc",
              label: "Localization Description",
            },
            {
              key: "system",
              label: "System",
            },
            {
              key: "active",
              label: "Active",
            },
        ],
        definitionSubFields: [
            {
              key: "type_code",
              label: "Type Code",
            },
            {
              key: "type_name",
              label: "Type Name",
            },
            {
              key: "parent",
              label: "Parent",
            },
            {
              key: "fcm_type",
              label: "FCM Types",
            },
            {
              key: "localization_key_title",
              label: "Localization Title",
            },
            {
              key: "localization_key_desc",
              label: "Localization Description",
            },
            {
              key: "system",
              label: "System",
            },
            {
              key: "active",
              label: "Active",
            },
        ],
    };
  },
  middleware: "authentication",
  mounted() {
      this.getNotificationsTypes();
  },

  methods: {
    async getNotificationsTypes(){
        this.isBusy = true;
        this.isBusyDefinitions = true;
        try {
            const query = 'return_all=1'
            const [typesResponse, setupResponse] = await Promise.all([
                Notification.getNotificationTypes(query),
                Notification.getNotificationTypesSetup(),
            ]);

            const existing = typesResponse.data.data || [];
            const definitions = (setupResponse.data && setupResponse.data.data) ? setupResponse.data.data : [];
            this.tableData = existing;
            this.newDefinitions = this.buildNewDefinitions(existing, definitions);

            this.$nextTick(() => {
                this.initSortable();
            });
        } catch (error) {
            this.error = error.response?.data?.error || "";
            this.tableData = []
            this.newDefinitions = []
        } finally {
            this.isBusy = false;
            this.isBusyDefinitions = false;
        }
    },

    // Refresh only the real notification types table.
    async refreshTypes() {
        this.isBusy = true;
        try {
            const response = await Notification.getNotificationTypes('return_all=1');
            this.tableData = response.data.data || [];
            this.$nextTick(() => {
                this.initSortable();
            });
        } catch (error) {
            this.error = error.response?.data?.error || "";
            this.tableData = [];
        } finally {
            this.isBusy = false;
        }
    },

    // Refresh only the available (not-yet-created) definitions table, diffing
    // the catalog against the currently loaded types.
    async refreshDefinitions() {
        this.isBusyDefinitions = true;
        try {
            const response = await Notification.getNotificationTypesSetup();
            const definitions = (response.data && response.data.data) ? response.data.data : [];
            this.newDefinitions = this.buildNewDefinitions(this.tableData, definitions);
        } catch (error) {
            this.error = error.response?.data?.error || "";
            this.newDefinitions = [];
        } finally {
            this.isBusyDefinitions = false;
        }
    },


    buildNewDefinitions(existing, definitions) {
        const existingByCode = {};
        const indexExisting = (list) => {
            (list || []).forEach((type) => {
                existingByCode[type.type_code] = type;
                indexExisting(type.sub_categories);
            });
        };
        indexExisting(existing);

        const result = [];

        (definitions || []).forEach((def) => {
            const newChildren = (def.sub_categories || [])
                .filter((child) => !existingByCode[child.type_code])
                .map((child) => ({ ...child, active: 0, _isNewDefinition: true }));

            if (!existingByCode[def.type_code]) {
                // Whole parent is new — include it with its new children.
                result.push({
                    ...def,
                    active: 0,
                    _isNewDefinition: true,
                    sub_categories: newChildren,
                });
            } else if (newChildren.length) {
                // Parent already exists — keep it as a (read-only) container that
                // reflects the real parent's active state.
                result.push({
                    ...def,
                    active: existingByCode[def.type_code].active,
                    _isNewDefinition: false,
                    _isExistingParent: true,
                    sub_categories: newChildren,
                });
            }
        });

        return result;
    },

    async updateNotificationType(item, value) {
        // New definition (from /notification/types/setup) not yet created for this
        // tenant — activating it creates the notification type.
        if (item._isNewDefinition) {
            if (value !== 1) {
                return;
            }
            if (item.parent) {
                const parentType = this.tableData.find((type) => type.type_code === item.parent);
                if (!parentType || !parentType.active) {
                    item.active = 0;
                    Swal.fire("Fail!", "Activate the parent type first.", "warning");
                    return;
                }
            }
            const confirm = await Swal.fire({
                title: "Are you sure?",
                text: "This notification type will be created and activated!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, activate it!",
            });

            if (!confirm.value) {
                item.active = 0;
                return;
            }

            try {
                const payload = {
                    type_code: item.type_code,
                    type_name: item.type_name,
                    system: item.system,
                    fcm_type: item.fcm_type,
                    app_order: item.app_order,
                    localization_key_title: item.localization_key_title,
                    localization_key_desc: item.localization_key_desc,
                    active: 1,
                };
                if (item.parent) {
                    payload.parent = item.parent;
                }
                const response = await Notification.createNotificationType(payload);
                if (response.data.data === true) {
                    Swal.fire("Created!", "Notification type created and activated!", "success");
                } else {
                    Swal.fire("Fail!", "Failed to create notification type.", "warning");
                }
            } catch (error) {
                item.active = 0;
                Swal.fire("Fail!", error.response?.data?.error || "Failed", "warning");
            }
            this.getNotificationsTypes();
            return;
        }

        if (value === 1 && item.parent) {
            const parentType = this.tableData.find((type) => type.type_code === item.parent);
            if (parentType && !parentType.active) {
                item.active = 0;
                Swal.fire("Fail!", "Cannot activate this notification type because its parent type is not active.", "warning");
                return;
            }
        }

        const action = value === 1 ? "activate" : "deactivate";
        const result = await Swal.fire({
            title: "Are you sure?",
            text: `This notification type will be ${action}d!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: `Yes, ${action} it!`,
        });

        if (!result.value) {
            item.active = value === 1 ? 0 : 1;
            return;
        }

        try {
            const response = await Notification.updateNotificationType(process.env.VUE_APP_TENANT, item.type_code, { active: value });
            if (response.data.data === true) {
                Swal.fire("Updated!", `Notification type ${action}d!`, "success");
            } else {
                Swal.fire("Fail!", "Failed to update notification type.", "warning");
            }
            this.getNotificationsTypes();
        } catch (error) {
            Swal.fire("Fail!", error.response?.data?.error || "Failed", "warning");
            this.getNotificationsTypes();
        }
    },

    async updateFcmType(item, value) {
        try {
            await Notification.updateNotificationType(process.env.VUE_APP_TENANT, item.type_code, { fcm_type: value });
        } catch (error) {
            Swal.fire("Fail!", error.response?.data?.error || "Failed to update FCM type", "warning");
            this.getNotificationsTypes();
        }
    },

    rowClass(item, type) {
        return type === "row" ? "notif-row" : null;
    },

    onToggleDetails(data) {
        const willShow = !data.detailsShowing;
        data.toggleDetails();
        if (willShow) {
            this.$nextTick(() => {
                this.initChildSortable(data.item);
            });
        }
    },

    async persistOrder(changedItems) {
        if (!changedItems || changedItems.length < 2) {
            return;
        }

        try {
            await Notification.reorderNotificationTypes({ items: changedItems });
        } catch (error) {
            Swal.fire("Fail!", error.response?.data?.error || "Failed to update order", "warning");
            this.getNotificationsTypes();
        }
    },

    // Moves the item within `list` and redistributes the *existing* app_order
    // values of only the displaced range among themselves (DB values are
    // reused as-is, never recalculated/renumbered for the whole list).
    reorderList(list, evt) {
        const { oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, item, from } = evt;
        if (oldIndex == null || newIndex == null || oldIndex === newIndex) {
            return null;
        }

        // Undo Sortable's direct DOM move so Vue can re-render from the data array
        const children = from.children;
        if (oldIndex < newIndex) {
            from.insertBefore(item, children[oldIndex]);
        } else {
            from.insertBefore(item, children[oldIndex + 1]);
        }

        if (oldDraggableIndex == null || newDraggableIndex == null || oldDraggableIndex === newDraggableIndex) {
            return null;
        }

        const lo = Math.min(oldDraggableIndex, newDraggableIndex);
        const hi = Math.max(oldDraggableIndex, newDraggableIndex);
        const orderValues = list.slice(lo, hi + 1)
            .map((entry) => entry.app_order)
            .sort((a, b) => a - b);

        const movedItem = list.splice(oldDraggableIndex, 1)[0];
        list.splice(newDraggableIndex, 0, movedItem);

        const changedItems = [];
        list.slice(lo, hi + 1).forEach((entry, idx) => {
            const newOrder = orderValues[idx];
            if (entry.app_order !== newOrder) {
                changedItems.push({ type_code: entry.type_code, app_order: newOrder });
                entry.app_order = newOrder;
            }
        });

        return changedItems;
    },

    initSortable() {
        const tableEl = this.$refs.notificationTypesTable && this.$refs.notificationTypesTable.$el;
        const tbody = tableEl && tableEl.querySelector("tbody");
        if (!tbody) {
            return;
        }

        if (this.sortableInstance) {
            this.sortableInstance.destroy();
        }

        this.sortableInstance = Sortable.create(tbody, {
            handle: ".drag-handle",
            draggable: ".notif-row",
            animation: 150,
            ghostClass: "sortable-ghost",
            onEnd: (evt) => {
                this.persistOrder(this.reorderList(this.tableData, evt));
            },
        });
    },

    initChildSortable(parentItem) {
        const ref = this.$refs[`subTable_${parentItem.type_code}`];
        const tableEl = Array.isArray(ref) ? ref[0] && ref[0].$el : ref && ref.$el;
        const tbody = tableEl && tableEl.querySelector("tbody");
        if (!tbody) {
            return;
        }

        if (this.childSortableInstances[parentItem.type_code]) {
            this.childSortableInstances[parentItem.type_code].destroy();
        }

        this.childSortableInstances[parentItem.type_code] = Sortable.create(tbody, {
            handle: ".drag-handle",
            animation: 150,
            ghostClass: "sortable-ghost",
            onEnd: (evt) => {
                this.persistOrder(this.reorderList(parentItem.sub_categories, evt));
            },
        });
    },

  },

    
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">

        <div class="card">
          <div class="card-body">

            <div class="d-flex align-items-center justify-content-between mb-3">
              <h4 class="card-title mb-0">Notification Types</h4>
              <a
                href="javascript:void(0);"
                class="btn btn-sm btn-primary waves-effect waves-light"
                @click="refreshTypes"
              >
                <i class="mdi mdi-refresh me-1"></i>Refresh
              </a>
            </div>

            <p class="text-muted mb-3">
                <i class="uil uil-bars me-1"></i>
                Drag rows by the handle to reorder notification types. Child types can only be reordered within their own parent.
            </p>
                  <!-- Table -->
            <b-table
                ref="notificationTypesTable"
                :busy="isBusy"
                table-class="table table-centered datatable table-card-list"
                thead-tr-class="bg-transparent"
                :tbody-tr-class="rowClass"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                show-empty
                empty-text="No Data Found"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>


              <template v-slot:cell(drag)="data">
                <span class="drag-handle" :data-type-code="data.item.type_code" style="cursor: move;">
                  <i class="uil uil-bars" style="font-size: 18px; color: #6c757d;"></i>
                </span>
              </template>

              <template v-slot:cell(expand)="data">
                <a
                  v-if="data.item.sub_categories && data.item.sub_categories.length"
                  href="javascript:void(0);"
                  class="text-body d-inline-flex align-items-center"
                  @click="onToggleDetails(data)"
                >
                  <i class="uil" :class="data.detailsShowing ? 'uil-angle-down' : 'uil-angle-right'"></i>
                  <span class="badge bg-light text-dark ms-1">{{ data.item.sub_categories.length }}</span>
                </a>
              </template>

              <template v-slot:cell(type_name)="data">
                <span>{{ data.item.type_name }}</span>
              </template>

              <template v-slot:row-details="data">
                <div class="sub-categories-table">
                  <b-table
                      :ref="'subTable_' + data.item.type_code"
                      table-class="table table-centered table-sm mb-0"
                      thead-tr-class="bg-transparent"
                      :items="data.item.sub_categories"
                      :fields="subCategoryFields"
                      responsive="sm"
                      show-empty
                      empty-text="No sub categories"
                  >
                    <template v-slot:cell(drag)="subData">
                      <span v-if="subData.item.active" class="drag-handle" :data-type-code="subData.item.type_code" style="cursor: move;">
                        <i class="uil uil-bars" style="font-size: 18px; color: #6c757d;"></i>
                      </span>
                    </template>

                    <template v-slot:cell(fcm_type)="subData">
                      <select
                        v-model="subData.item.fcm_type"
                        class="form-select form-select-sm"
                        style="min-width: 90px;"
                        :disabled="!subData.item.active"
                        @change="updateFcmType(subData.item, subData.item.fcm_type)"
                      >
                        <option value="topic">topic</option>
                        <option value="batch">batch</option>
                      </select>
                    </template>

                    <template v-slot:cell(system)="subData">
                      <span>{{ subData.item.system === 'Y' ? 'Yes' : 'No' }}</span>
                    </template>

                    <template v-slot:cell(active)="subData">
                      <div class="form-check form-switch form-switch-lg mb-0">
                        <input
                            v-model="subData.item.active"
                            type="checkbox"
                            class="form-check-input"
                            :true-value="1"
                            :false-value="0"
                            :disabled="!data.item.active"
                            @change="updateNotificationType(subData.item, subData.item.active)"
                        />
                      </div>
                    </template>
                  </b-table>
                </div>
              </template>

              <template v-slot:cell(fcm_type)="data">
                <select
                  v-model="data.item.fcm_type"
                  class="form-select form-select-sm"
                  style="min-width: 90px;"
                  :disabled="!data.item.active"
                  @change="updateFcmType(data.item, data.item.fcm_type)"
                >
                  <option value="topic">topic</option>
                  <option value="batch">batch</option>
                </select>
              </template>

              <template v-slot:cell(system)="data">
               <span>{{data.item.system === 'Y' ? 'Yes' : 'No'}}</span>
              </template>

              <template v-slot:cell(active)="data">
                <div class="form-check form-switch form-switch-lg mb-0">
                  <input
                    v-model="data.item.active"
                    type="checkbox"
                    class="form-check-input"
                    :true-value="1"
                    :false-value="0"
                    @change="updateNotificationType(data.item, data.item.active)"
                  />
                </div>
              </template>
            </b-table>
                </div>
              </div>
          </div>
        </div>
        
    <!-- New (not-yet-created) definitions -->
    <div v-if="newDefinitions.length" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <h4 class="card-title mb-0">Available Notification Types</h4>
              <a
                href="javascript:void(0);"
                class="btn btn-sm btn-primary waves-effect waves-light"
                @click="refreshDefinitions"
              >
                <i class="mdi mdi-refresh me-1"></i>Refresh
              </a>
            </div>
            <p class="text-muted mb-3">
              These notification types exist in the common definitions but haven't been created for this tenant yet.
              Toggle <strong>Active</strong> to create and enable one.
            </p>

            <b-table
                :busy="isBusyDefinitions"
                table-class="table table-centered datatable table-card-list"
                thead-tr-class="bg-transparent"
                :items="newDefinitions"
                :fields="definitionFields"
                responsive="sm"
                show-empty
                empty-text="No new definitions"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(expand)="data">
                <a
                  v-if="data.item.sub_categories && data.item.sub_categories.length"
                  href="javascript:void(0);"
                  class="text-body d-inline-flex align-items-center"
                  @click="data.toggleDetails()"
                >
                  <i class="uil" :class="data.detailsShowing ? 'uil-angle-down' : 'uil-angle-right'"></i>
                  <span class="badge bg-light text-dark ms-1">{{ data.item.sub_categories.length }}</span>
                </a>
              </template>

              <template v-slot:cell(fcm_type)="data">
                <span>{{ data.item.fcm_type }}</span>
              </template>

              <template v-slot:cell(system)="data">
                <span>{{ data.item.system === 'Y' ? 'Yes' : 'No' }}</span>
              </template>

              <template v-slot:cell(active)="data">
                <span v-if="data.item._isExistingParent" class="text-muted">
                  {{ data.item.active == 1 ? 'Yes' : 'No' }}
                </span>
                <div v-else class="form-check form-switch form-switch-lg mb-0">
                  <input
                    v-model="data.item.active"
                    type="checkbox"
                    class="form-check-input"
                    :true-value="1"
                    :false-value="0"
                    title="This notification type is not created yet. Clicking Activate will create it for this tenant and enable it."
                    @change="updateNotificationType(data.item, data.item.active)"
                  />
                </div>
              </template>

              <template v-slot:row-details="data">
                <div class="sub-categories-table">
                  <b-table
                      table-class="table table-centered table-sm mb-0"
                      thead-tr-class="bg-transparent"
                      :items="data.item.sub_categories"
                      :fields="definitionSubFields"
                      responsive="sm"
                      show-empty
                      empty-text="No sub categories"
                  >
                    <template v-slot:cell(fcm_type)="subData">
                      <span>{{ subData.item.fcm_type }}</span>
                    </template>

                    <template v-slot:cell(system)="subData">
                      <span>{{ subData.item.system === 'Y' ? 'Yes' : 'No' }}</span>
                    </template>

                    <template v-slot:cell(active)="subData">
                      <div class="form-check form-switch form-switch-lg mb-0">
                        <input
                            v-model="subData.item.active"
                            type="checkbox"
                            class="form-check-input"
                            :true-value="1"
                            :false-value="0"
                            :disabled="!data.item.active"
                            title="This notification type is not created yet. Clicking Activate will create it for this tenant and enable it."
                            @change="updateNotificationType(subData.item, subData.item.active)"
                        />
                      </div>
                    </template>
                  </b-table>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <!-- MODALS -->
    <!-- END  MODALS -->

  </Layout>
</template>
<style scoped>
.sortable-ghost {
  opacity: 0.5;
}

.sub-categories-table {
  background-color: #f7f8fb;
  border-radius: 6px;
  padding: 8px 12px;
}

.table-card-list tbody tr:hover {
  background-color: #f9f9f9; /* Highlight row on hover */
  transition: background-color 0.2s ease; /* Smooth transition for hover effect */
}

/* Hide the delete button by default */
.action-container .delete-btn {
  display: none;
}

/* Show the delete button on row hover */
.table-card-list tbody tr:hover .action-container .delete-btn {
  display: inline-block;
}

/* Show setup_datetime-else when hover if delete button is not visible */
.table-card-list tbody tr:hover .setup-datetime {
  display: none;
}

/* Show the setup_datetime if the delete button is not visible */
.table-card-list tbody tr:hover .setup-datetime-else {
  display: inline-block;
}

/* Optionally, change the background color of the row when hovered */
.table-card-list tbody tr.row-hover {
  background-color: #f0f8ff; /* Light blue on hover */
}
.action-container {
  display: flex;
  justify-content: space-between; /* Move delete button to the right */
  align-items: center; /* Vertically center the items */
}

.delete-btn {
  margin-left: auto; /* Ensure delete button moves to the right */
}
</style>
